import Text from '@/components/Text';

export const FormatExpressionExamples = () => {
    return (
        <>
            <Text.Body className='mt-6 text-base font-medium text-textPrimary'>Examples</Text.Body>
            <div className='relative z-0 px-1 mt-2'>
                <div
                    style={{
                        fontFamily: 'Menlo, Monaco, "Courier New", monospace',
                        fontWeight: 'normal',
                        fontSize: '12px',
                        fontFeatureSettings: '"liga" 0, "calt" 0',
                        fontVariationSettings: 'normal',
                        lineHeight: '18px',
                        letterSpacing: '0px'
                    }}
                    className='overflow-hidden divide-x divide-outlinePrimary space-x-4 flex p-3 mt-1 h-32 w-full !outline-none monaco-editor monaco-mouse-cursor-text'
                >
                    <span className='w-[15rem] overflow-hidden'>
                        <span className=''>
                            <span className='mtk7 text-formatExpressionLiteral'>// Math operations</span>
                        </span>
                        <br />
                        <span className='view-line'>
                            <span className='mtk9 text-formatExpressionTemplateDelimiter bracket-highlighting-1'>
                                {'{{ '}
                            </span>
                            <span className='mtk1'>$</span>
                            <span className='mtk9 bracket-highlighting-2'>[</span>
                            <span className='mtk5'>'columnName'</span>
                            <span className='mtk9 bracket-highlighting-2'>]</span>
                            <span className='mtk9'> /</span>
                            <span className='mtk6'> 1000</span>
                            <span className='mtk9 bracket-highlighting-1 text-formatExpressionTemplateDelimiter'>
                                {' }}'}
                            </span>
                        </span>

                        <br />
                        <br />

                        <span className=''>
                            <span className='mtk7 text-formatExpressionLiteral'>// String formatting</span>
                        </span>
                        <br />
                        <span className=''>
                            <span className='mtk9 text-formatExpressionTemplateDelimiter bracket-highlighting-1'>
                                {'{{ '}
                            </span>
                            <span className='mtk1'>$</span>
                            <span className='mtk9 bracket-highlighting-2'>[</span>
                            <span className='mtk5'>'columnName'</span>
                            <span className='mtk9 bracket-highlighting-2'>]</span>
                            <span className='mtk9 bracket-highlighting-1 text-formatExpressionTemplateDelimiter'>
                                {' }} '}
                            </span>
                            <span className='mtk7 text-formatExpressionLiteral'>mins</span>
                        </span>
                    </span>

                    <span className='w-[26rem] overflow-hidden pl-3'>
                        <span className=''>
                            <span className='mtk7 text-formatExpressionLiteral'>// Multi-line expressions</span>
                        </span>
                        <br />
                        <span className=''>
                            <span className='mtk9 text-formatExpressionTemplateDelimiter bracket-highlighting-1'>
                                {'{{'}
                            </span>
                            <br />
                            <span>
                                <span className='mtk1'>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <span className='mtk8'>const</span>
                                <span className='mtk1'>&nbsp;total&nbsp;</span>
                                <span className='mtk9'>=</span>
                                <span className='mtk1'>&nbsp;$rows</span>
                                <span className='mtk9'>.</span>
                                <span className='mtk1'>reduce</span>
                                <span className='mtk9 bracket-highlighting-2'>(</span>
                                <span className='mtk9 bracket-highlighting-3'>(</span>
                                <span className='mtk1'>a</span>
                                <span className='mtk9'>,</span>
                                <span className='mtk1'>&nbsp;b</span>
                                <span className='mtk9 bracket-highlighting-3'>)</span>
                                <span className='mtk1'>&nbsp;</span>
                                <span className='mtk9'>=&gt;</span>
                                <span className='mtk1'>&nbsp;a&nbsp;</span>
                                <span className='mtk9'>+</span>
                                <span className='mtk1'>&nbsp;b</span>
                                <span className='mtk9 bracket-highlighting-2'>)</span>
                                <span className='mtk9'>;</span>
                            </span>
                            <br />
                            <span>
                                <span className='mtk1'>&nbsp;&nbsp;&nbsp;&nbsp;$</span>
                                <span className='mtk9 bracket-highlighting-2'>[</span>
                                <span className='mtk5'>'incidents.active'</span>
                                <span className='mtk9 bracket-highlighting-2'>]</span>
                                <span className='mtk1'>&nbsp;</span>
                                <span className='mtk9'>/</span>
                                <span className='mtk1'>&nbsp;total</span>
                            </span>
                            <br />
                            <span className='mtk9 bracket-highlighting-1 text-formatExpressionTemplateDelimiter'>
                                {' }}'}
                            </span>
                            <span className='mtk7 text-formatExpressionLiteral'>%</span>
                        </span>
                    </span>
                </div>
            </div>
        </>
    );
};
